import(/* webpackMode: "eager" */ "/var/www/pediloo/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pediloo/app/header-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentBanner"] */ "/var/www/pediloo/components/CookieConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorReporter"] */ "/var/www/pediloo/components/ErrorReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pediloo/components/footer-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileBottomNav"] */ "/var/www/pediloo/components/MobileBottomNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileCompletionModal"] */ "/var/www/pediloo/components/ProfileCompletionModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/pediloo/components/ui/toast/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/var/www/pediloo/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/var/www/pediloo/lib/SettingsContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/pediloo/node_modules/.pnpm/next@14.2.16_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/pediloo/providers/AuthProvider.tsx");
